var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0808545 8.89368C0.197363 7.28172 1.46455 6.03022 3.07746 5.9277C4.04202 5.86639 5.22142 5.81818 6.54545 5.81818C7.86948 5.81818 9.04889 5.86639 10.0135 5.9277C11.6264 6.03022 12.8935 7.28172 13.0101 8.89368C13.0571 9.54428 13.0909 10.2436 13.0909 10.9091C13.0909 11.5746 13.0571 12.2739 13.0101 12.9245C12.8935 14.5365 11.6264 15.788 10.0135 15.8905C9.04889 15.9518 7.86949 16 6.54545 16C5.22142 16 4.04202 15.9518 3.07746 15.8905C1.46455 15.788 0.197363 14.5365 0.0808546 12.9245C0.0338308 12.2739 0 11.5746 0 10.9091C0 10.2436 0.0338308 9.54428 0.0808545 8.89368ZM8 10.1818C8 10.7202 7.70749 11.1903 7.27273 11.4418V12.3636C7.27273 12.7653 6.94712 13.0909 6.54545 13.0909C6.14379 13.0909 5.81818 12.7653 5.81818 12.3636V11.4418C5.38342 11.1903 5.09091 10.7202 5.09091 10.1818C5.09091 9.37849 5.74213 8.72727 6.54545 8.72727C7.34878 8.72727 8 9.37849 8 10.1818Z",
    fill: "url(#paint0_radial_9537_5746)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90942 3.63636C2.90942 1.62806 4.53748 0 6.54579 0C8.5541 0 10.1822 1.62806 10.1822 3.63636V6.54545C10.1822 6.94712 9.85654 7.27273 9.45488 7.27273C9.05322 7.27273 8.72761 6.94712 8.72761 6.54545V3.63636C8.72761 2.43138 7.75077 1.45455 6.54579 1.45455C5.3408 1.45455 4.36397 2.43138 4.36397 3.63636V6.54545C4.36397 6.94712 4.03836 7.27273 3.6367 7.27273C3.23503 7.27273 2.90942 6.94712 2.90942 6.54545V3.63636Z",
    fill: "url(#paint1_radial_9537_5746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9537_5746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.54545 10.9091) rotate(90) scale(5.09091 6.54545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9537_5746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.54579 3.63636) rotate(90) scale(3.63636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.80baf44860fec9eb358fb69ca296d345.svg";
export { ForwardRef as ReactComponent };